import {Accordion as MuiAccordion, AccordionProps} from '@mui/material'

const Accordion = (props: AccordionProps & {name: string}) => <MuiAccordion {...props} />

export default Accordion
